export default function nullToBottomSort(a, b) {
  return <any>(a === null) - <any>(b === null);
}
